
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandD as ObiOwnShipNoCommandDElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-d.js';
 
 
 

 
 export const ObiOwnShipNoCommandD = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-d',
   elementClass: ObiOwnShipNoCommandDElement,
   events: {
     
   }
  });
 
 